import { Map } from "immutable";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { reduxForm } from "redux-form/immutable";

import { UserAccountType } from "common/types/user";

import { FeedbackDetails } from "seneca-common/features/feedback/types";
import { getUserAccountType } from "seneca-common/features/user/state";
import { toJS } from "seneca-common/utils/components/toJS";

import { ModuleDetails } from "features/classroom/features/feedback/hooks/useGetModuleDetails";
import ErrorHandler from "features/common/components/ErrorHandler";
import { getAppVersion } from "features/common/utils/functions/app";
import { getBrowserDetails } from "features/common/utils/functions/browser";

import { validateFeedback } from "../../utils";
import FeedbackForm from "./FeedbackForm";

type MakeFeedbackModal = {
  formName: string;
  saveFeedbackAction: (arg0: FeedbackDetails) => any;
  showWellbeingMessage?: boolean;
};

type Props = {
  accountType?: UserAccountType | null;
  feedbackType?: string;
  moduleDetails?: ModuleDetails;
  saveFeedback: (details: FeedbackDetails) => Promise<void>;
  onSubmitSuccess?: () => void;
  meta: FeedbackDetails["meta"];
};

export default function makeFeedbackForm({
  formName,
  saveFeedbackAction,
  showWellbeingMessage
}: MakeFeedbackModal) {
  const mapStateToProps = (state: any) => ({
    accountType: getUserAccountType(state),
    showWellbeingMessage
  });

  const mapDispatchToProps = (dispatch: any) => {
    return {
      saveFeedback: (feedbackDetails: FeedbackDetails) =>
        dispatch(saveFeedbackAction(feedbackDetails))
    };
  };

  const ReduxFormWrappedFeedbackForm = reduxForm({
    form: `${formName}-feedback-form`,
    // @ts-ignore
    validate: validateFeedback,
    onSubmit: async (
      formValues: Map<string, string>,
      dispatch: any,
      {
        accountType,
        feedbackType,
        moduleDetails,
        meta,
        saveFeedback,
        onSubmitSuccess
      }: Props
    ) => {
      const feedback = formValues.get("feedback") || "";

      const feedbackDetails = {
        accountType,
        feedbackType: feedbackType || formValues.get("feedbackType") || "",
        feedback,
        browser: getBrowserDetails(),
        appVersion: getAppVersion(),
        meta: {
          ...meta,
          moduleType: moduleDetails?.moduleType,
          content: moduleDetails?.content,
          userAnswer: moduleDetails?.userAnswer
        }
      };

      await saveFeedback(feedbackDetails);

      onSubmitSuccess && onSubmitSuccess();
    }
  })(FeedbackForm as any);

  return ErrorHandler(
    withRouter(
      // @ts-ignore
      connect(
        mapStateToProps,
        mapDispatchToProps
      )(toJS(ReduxFormWrappedFeedbackForm))
    )
  );
}
